import React, { useState, useEffect, useContext, useMemo } from "react";
import MainContainer from "../../components/MainContainer";
import MainHeader from "../../components/MainHeader";
import Title from "../../components/Title";
import MainHeaderButtonsWrapper from "../../components/MainHeaderButtonsWrapper";
import { Button, Paper, TextField, Select, MenuItem, FormControl, Tabs, Tab } from "@mui/material";
import SelectConection from "../../components/SelectConection";

import { makeStyles } from 'tss-react/mui';

import TemplateMessageTable from "../../components/TemplateMessageTable";
import TemplateMessageDialog from "../../components/TemplateMessageDialog";
import ConfirmationModal from "../../components/ConfirmationModal";

import { i18n } from "../../translate/i18n";
import { toast } from "../../services/toast";

import useTemplateMessage from "../../hooks/useTemplateMessage";
import { AuthContext } from "../../context/Auth/AuthContext";
import { socketConnection } from "../../services/socket";
import Box from "@mui/material/Box";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import api from "../../services/api";

const useStyles = makeStyles()(theme => ({
  mainPaper: {
    flex: 1,
    padding: theme.spacing(1),
    overflowY: "scroll",
    ...theme.scrollbarStyles
  }
}));

function TemplateMessage() {
  const { classes } = useStyles();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [messageSelected, setMessageSelected] = useState({});
  const [showOnDeleteDialog, setShowOnDeleteDialog] = useState(false);
  const [searchParam, setSearchParam] = useState("");

  const [filterVisible, setFilterVisible] = useState("");
  const [tabUso, setTabUso] = useState("no");
  const [filterWhatsapp, setFilterWhatsapp] = useState("");

  const {
    list: listMessages,
    save: saveMessage,
    update: updateMessage,
    deleteRecord: deleteMessage
  } = useTemplateMessage();

  const [costsOpen, setCostsOpen] = useState(false);
  const DIAS_GASTO = 30;
  const [costsLoading, setCostsLoading] = useState(false);
  const [costs, setCosts] = useState(null);

  useEffect(() => {
    setCosts(null);
    setCostsOpen(false);
  }, [filterWhatsapp]);

  const loadCosts = async (days = DIAS_GASTO, refresh = false) => {
    if (!filterWhatsapp) {
      toast.info("Elige una conexión para ver el gasto por plantilla.");
      return;
    }

    setCostsLoading(true);
    try {
      const { data } = await api.get("/template-message/analytics", {
        params: {
          whatsappId: filterWhatsapp,
          days,
          ...(refresh ? { refresh: 1 } : {})
        }
      });
      setCosts(data);
      setCostsOpen(true);
      if (refresh) {
        toast.success(
          `Actualizado desde Meta: ${data?.sync?.templates || 0} plantillas.`
        );
      }
    } catch (e) {
      setCosts(null);
      toast.error(e);
    } finally {
      setCostsLoading(false);
    }
  };

  const costByTemplate = useMemo(() => {
    const map = {};
    (costs?.rows || []).forEach((r) => {
      map[String(r.templateId)] = r;
    });
    return map;
  }, [costs]);

  const money = (n) =>
    typeof n === "number"
      ? `${n.toFixed(n < 1 ? 4 : 2)} US$`
      : "—";

  const { user } = useContext(AuthContext);

  useEffect(() => {
    const fetchData = async () => {
      await loadingTemplates();
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketConnection({ companyId });
    socket.on(`company-${companyId}-TemplateMessage`, () => {
      loadingTemplates();
    });
    return () => socket.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtradas = useMemo(() => {
    return (messages || []).filter((item) => {
      if (searchParam && !(item.name || "").toLowerCase().includes(searchParam)) {
        return false;
      }
      if (filterVisible === "yes" && item.visibleToAgent === false) return false;
      if (filterVisible === "no" && item.visibleToAgent !== false) return false;
      if (filterWhatsapp && String(item.whatsappId) !== String(filterWhatsapp)) {
        return false;
      }
      return true;
    });
  }, [messages, searchParam, filterVisible, filterWhatsapp]);

  const conteoUso = useMemo(
    () => ({
      no: filtradas.filter((i) => i.forCampaign !== true).length,
      yes: filtradas.filter((i) => i.forCampaign === true).length
    }),
    [filtradas]
  );

  const displayedMessages = useMemo(
    () =>
      filtradas.filter((i) =>
        tabUso === "yes" ? i.forCampaign === true : i.forCampaign !== true
      ),
    [filtradas, tabUso]
  );

  const loadingTemplates = async () => {
    setLoading(true);
    try {
      const companyId = localStorage.getItem("companyId");
      const data = await listMessages({ companyId, userId: user.id });
      setMessages(data);
    } catch (e) {
      toast.error(e);
    }
    setLoading(false);
  };

  const handleOpenToAdd = () => {
    setMessageSelected({});
    setModalOpen(true);
  };

  const handleOpenToEdit = message => {
    setMessageSelected(message);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setMessageSelected({});
  };

  const handleSave = async message => {
    handleCloseModal();
    try {
      const res = await saveMessage(message);
      await loadingTemplates();
      if (res?.metaWarning) {
        toast.warning(res.metaWarning, { duration: 10000 });
      } else {
        toast.success("Plantilla creada. Enviada a Meta para aprobación.");
      }
    } catch (e) {
      toast.error(e);
    }
  };

  const Refresh = async () => {
    handleCloseModal();
    try {
      await loadingTemplates();
      toast.success("Mensaje actualizado con éxito.");
    } catch (e) {
      toast.error(e);
    }
  };

  const handleEdit = async message => {
    handleCloseModal();
    try {
      const res = await updateMessage(message);
      await loadingTemplates();
      if (res?.metaWarning) {
        toast.warning(res.metaWarning, { duration: 10000 });
      } else if (res?.metaSubmitted) {
        toast.success("Guardada y enviada a Meta para aprobación.");
      } else if (res?.metaSkipReason) {
        toast.info(`Guardada. ${res.metaSkipReason}`, { duration: 8000 });
      } else {
        toast.success("Plantilla guardada.");
      }
    } catch (e) {
      toast.error(e);
    }
  };

  const handleDelete = async message => {
    handleCloseModal();

    if (user.profile === "user") {
      return toast.error(
        "Solo un administrador o supervisor puede eliminar los registros!"
      );
    }

    try {
      await deleteMessage(message.id);
      await loadingTemplates();
      toast.success("Mensaje eliminado con éxito.");
    } catch (e) {
      toast.error(e);
    }
  };

  const handleSearch = event => {
    setSearchParam(event.target.value.toLowerCase());
  };

  return (
    <MainContainer maxWidth={false}>
      <MainHeader>
        <Title>{i18n.t("templateMessage.title")}</Title>

        <MainHeaderButtonsWrapper>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1
            }}>
            <TextField
              placeholder="Buscar por nombre…"
              type="search"
              size="small"
              value={searchParam}
              onChange={handleSearch}
              sx={{ minWidth: 220 }}
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon style={{ color: "gray" }} />
                    </InputAdornment>
                  )
                }
              }}
            />

            {}
            <FormControl size="small" sx={{ minWidth: 170 }}>
              <Select
                displayEmpty
                value={filterVisible}
                onChange={(e) => setFilterVisible(e.target.value)}
                renderValue={(v) =>
                  v === "yes"
                    ? "Para agentes"
                    : v === "no"
                    ? "Uso interno"
                    : "Visibilidad: todas"
                }
              >
                <MenuItem value="">Todas</MenuItem>
                <MenuItem value="yes">Para agentes</MenuItem>
                <MenuItem value="no">Uso interno del sistema</MenuItem>
              </Select>
            </FormControl>

            {}
            <Box sx={{ minWidth: 190 }}>
              <SelectConection
                value={filterWhatsapp}
                channel="whatsapp_cloud"
                isConnected={null}
                onChange={(v) => setFilterWhatsapp(v)}
              />
            </Box>
            {filterWhatsapp && (
              <Button
                variant="outlined"
                color="primary"
                disabled={costsLoading}
                onClick={() => loadCosts()}
              >
                {costsLoading ? "Consultando…" : "Ver gasto"}
              </Button>
            )}

            <Button variant="contained" color="primary" onClick={handleOpenToAdd}>
              {i18n.t("templateMessage.buttons.add") ||
                i18n.t("quickMessages.buttons.add")}
            </Button>
          </Box>
        </MainHeaderButtonsWrapper>
      </MainHeader>
      <Paper className={classes.mainPaper} variant="outlined">
        {costsOpen && costs && (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 3,
              alignItems: "center",
              p: 1.5,
              mb: 1.5,
              borderRadius: 1,
              border: "1px solid",
              borderColor: "divider",
              backgroundColor: "action.hover"
            }}
          >
            <Box>
              <Typography variant="caption" color="textSecondary">
                Gasto total
              </Typography>
              <Typography sx={{ fontWeight: 700, fontSize: 20 }}>
                {money(costs.totals?.cost)}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="textSecondary">
                Enviados
              </Typography>
              <Typography sx={{ fontWeight: 600 }}>
                {costs.totals?.sent ?? 0}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="textSecondary">
                Entregados
              </Typography>
              <Typography sx={{ fontWeight: 600 }}>
                {costs.totals?.delivered ?? 0}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="textSecondary">
                Leídos
              </Typography>
              <Typography sx={{ fontWeight: 600 }}>
                {costs.totals?.read ?? 0}
              </Typography>
            </Box>

            <Box>
              <Typography variant="caption" color="textSecondary">
                Coste por mensaje
              </Typography>
              <Typography sx={{ fontWeight: 600 }}>
                {costs.totals?.sent
                  ? money(costs.totals.cost / costs.totals.sent)
                  : "—"}
              </Typography>
            </Box>

            <Box sx={{ ml: "auto", textAlign: "right" }}>
              <Typography variant="caption" color="textSecondary" display="block">
                Últimos {DIAS_GASTO} días, según Meta
              </Typography>
              <Typography variant="caption" color="textSecondary" display="block">
                {costs.lastSyncAt
                  ? `Sincronizado: ${new Date(costs.lastSyncAt).toLocaleString()}${costs.refreshingInBackground ? " · actualizando…" : ""}`
                  : "Sin sincronizar todavía"}
              </Typography>
              <Button
                size="small"
                disabled={costsLoading}
                onClick={() => loadCosts(DIAS_GASTO, true)}
              >
                Actualizar desde Meta
              </Button>
              <Button size="small" onClick={() => setCostsOpen(false)}>
                Ocultar
              </Button>
            </Box>
          </Box>
        )}

        <Tabs
          value={tabUso}
          onChange={(e, v) => setTabUso(v)}
          sx={{
            minHeight: 40,
            mb: 1,
            borderBottom: 1,
            borderColor: "divider",
            "& .MuiTab-root": { minHeight: 40, textTransform: "none" }
          }}
        >
          <Tab value="no" label={`Plantillas (${conteoUso.no})`} />
          <Tab value="yes" label={`De campañas (${conteoUso.yes})`} />
        </Tabs>

        <TemplateMessageTable
          readOnly={false}
          messages={displayedMessages}
          ocultarMarcaCampana={tabUso === "yes"}
          costByTemplate={costsOpen ? costByTemplate : null}
          showLoading={loading}
          editMessage={handleOpenToEdit}
          deleteMessage={message => {
            setMessageSelected(message);
            setShowOnDeleteDialog(true);
          }}
        />
      </Paper>
      <TemplateMessageDialog
        messageSelected={messageSelected}
        modalOpen={modalOpen}
        onClose={handleCloseModal}
        editMessage={handleEdit}
        saveMessage={handleSave}
        refresh={Refresh}
      />
      <ConfirmationModal
        title="Eliminar Registro"
        open={showOnDeleteDialog}
        onClose={setShowOnDeleteDialog}
        onConfirm={async () => {
          await handleDelete(messageSelected);
        }}
      >
        ¿Realmente desea eliminar este registro?
      </ConfirmationModal>
    </MainContainer>
  );
}

export default TemplateMessage;
